import React, { useState } from "react";
import { Close } from "../../assets/image";

export const EditCategoryModal = ({ category, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title: category.tittle || "",
    type: category.categoryType || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    const data = {
      tittle: formData.title,
      categoryType: formData.type,
    };
    onSave(data);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl w-full max-w-md shadow-lg relative">
        <div className="p-4">
          <div className="flex justify-between mb-3">
            <h2 className="text-xl text-primary font-semibold">Edit Category</h2>
            <button onClick={onClose} className="p-1.5 rounded-full">
              <img src={Close} alt="" className="w-5 h-5" />
            </button>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter category title"
              className="w-full border px-3 py-2 rounded-md text-sm"
            />
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">Category Type</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded-md text-sm"
            >
              <option value="blog">Blog</option>
              <option value="story">Story</option>
            </select>
          </div>

          <div className="flex justify-end gap-3">
            <button onClick={onClose} className="px-4 py-2 text-sm border rounded-md hover:bg-gray-100">
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 text-sm bg-primary text-white rounded-md hover:bg-[#00008B]"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
